import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Government from './pages/Government';
import Portfolio from './pages/Portfolio';
import Overview from './pages/company/Overview';
import Expertise from './pages/company/Expertise';
import VisionMission from './pages/company/VisionMission';
import ManagementTeam from './pages/company/ManagementTeam';
import WhyEGB from './pages/company/WhyEGB';
import Awards from './pages/company/Awards';
import Strategy from './pages/strategy/Strategy';
import AIServices from './pages/ai/AIServices';
import Training from './pages/Training';
import Careers from './pages/Careers';
import AdminCareers from './pages/AdminCareers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Sitemap from './pages/Sitemap';
import FAQ from './pages/FAQ';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Header />
        <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/government" element={<Government />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/company/overview" element={<Overview />} />
        <Route path="/company/expertise" element={<Expertise />} />
        <Route path="/company/vision-mission" element={<VisionMission />} />
        <Route path="/company/management-team" element={<ManagementTeam />} />
        <Route path="/company/why-egb" element={<WhyEGB />} />
        <Route path="/company/awards" element={<Awards />} />
        <Route path="/strategy" element={<Strategy />} />
        <Route path="/ai-services" element={<AIServices />} />
        <Route path="/training" element={<Training />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/admin/careers" element={<AdminCareers />} />
        <Route path="/admin/login" element={<AdminCareers />} />
        <Route path="/admin/login" element={<AdminCareers />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
